import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css" ;

const Login = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Updated Form Data:", formData); // Debugging
  }, [formData]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://taskpri.hariombusinessenterprise.com/logup.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      alert(result.success || result.error);

      if (result.success) {
        setTimeout(() => {  // ✅ Delay reset to prevent browser memory
          setFormData({ username: "", password: "" });
          console.log("Form Data after delayed reset:", formData);
        }, 0);
        
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="logincontainer">
    <form onSubmit={handleSubmit}>
      <input type="text" name="username" placeholder="Username" value={formData.username} onChange={handleChange} autoComplete="off" required />
      <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} autoComplete="new-password" required />
      <button type="submit">Login</button>
    </form>
    </div>
  );
};

export default Login;
